import { Charts } from './Charts';
import InfrastructureChartsDataProvider from './contexts/InfrastructureChartsDataContext';

const InfrastructureWrapper = () => {
    return (
        <InfrastructureChartsDataProvider>
            <Charts />
        </InfrastructureChartsDataProvider>
    );
};

export default InfrastructureWrapper;
